const customer2_title_reducer = (state = "", action) => {
	switch(action.type) {

		case 'UPDATECUST2TITLE':
			return typeof action.payload !== "undefined" ? action.payload : "";

		default:
			return state;
	}
}

export default customer2_title_reducer;